const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

function authHeader() {
  const token = localStorage.getItem("admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(method, path, body) {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error((await res.json()).message || "Server error");
  return res.json();
}

// ── Auth ──
export const adminLogin = (email, password) =>
  request("POST", "/auth/login", { email, password });

// ── Tours ──
export const fetchAdminTours = () => request("GET", "/admin/tours");
export const createTour = (data) => request("POST", "/admin/tours", data);
export const updateTour = (id, data) => request("PUT", `/admin/tours/${id}`, data);
export const deleteTour = (id) => request("DELETE", `/admin/tours/${id}`);

// ── Bookings ──
export const fetchAdminBookings = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return request("GET", `/admin/bookings${q ? `?${q}` : ""}`);
};
export const updateBookingStatus = (id, status) =>
  request("PATCH", `/admin/bookings/${id}/status`, { status });

// ── Users ──
export const fetchAdminUsers = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return request("GET", `/admin/users${q ? `?${q}` : ""}`);
};
export const updateUserRole = (id, role) =>
  request("PATCH", `/admin/users/${id}/role`, { role });

// ── Stats ──
export const fetchStats = () => request("GET", "/admin/stats");

// ── Images ──
export const fetchAdminImages = () => request("GET", "/admin/images");
export const createImage = (data) => request("POST", "/admin/images", data);
export const deleteImage = (id) => request("DELETE", `/admin/images/${id}`);

// ── Stops ──
export const fetchAdminStops = (tourId) =>
  request("GET", `/admin/stops${tourId ? `?tour_id=${tourId}` : ""}`);
export const createStop = (data) => request("POST", "/admin/stops", data);
export const updateStop = (id, data) => request("PUT", `/admin/stops/${id}`, data);
export const deleteStop = (id) => request("DELETE", `/admin/stops/${id}`);

// ── Tags ──
export const fetchAdminTags = (tourId) => request("GET", `/admin/tags?tour_id=${tourId}`);
export const createTag = (data) => request("POST", "/admin/tags", data);
export const deleteTag = (id) => request("DELETE", `/admin/tags/${id}`);